import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getChamberListing } from 'services/warehouseService';
import { formatDateTime } from 'utils/dateTime';

function extractChamberList(responseData) {
  const list = Array.isArray(responseData)
    ? responseData
    : Array.isArray(responseData?.data?.data)
      ? responseData.data.data
      : Array.isArray(responseData?.data)
        ? responseData.data
        : [];
  return list.map((item) => ({
    ...item,
    id: item.id ?? '-',
    type_of_racking: item.type_of_racking ?? '-',
    pallet_count: item.pallet_count ?? '-',
    created_at: formatDateTime(item.created_at),
    is_layout: item.is_layout,
    chamber_name: item.chamber_name ?? '-',
    temp_type: item.temp_type ?? '-',
    temp_max_range: item.temp_max_range,
    temp_min_range: item.temp_min_range,
    refrigeration_type: item.refrigeration_type ?? '-',
    chamber_capacity: item.chamber_capacity,
    movement_height: item.movement_height,
    pallet_dimension_height: item.pallet_dimension_height,
    pallet_dimension_length: item.pallet_dimension_length,
    pallet_dimension_breadth: item.pallet_dimension_breadth,
    chamber_height: item.chamber_height,
    chamber_length: item.chamber_length,
    chamber_breadth: item.chamber_breadth,
    floor_number: item.floor_number,
    controlled_atmosphere: item.controlled_atmosphere,
    humidifier: item.humidifier,
    ozone_filteration: item.ozone_filteration,
    gate_lock: item.gate_lock,
    oxygen_level: item.oxygen_level
  }));
}

export const fetchChamberListing = createAsyncThunk(
  'chamber/fetchListing',
  async (args, { rejectWithValue }) => {
    const warehouseId = typeof args === 'object' ? args?.warehouseId : args;
    const page = typeof args === 'object' ? Number(args?.page || 1) : 1;
    const limit = typeof args === 'object' ? Number(args?.limit || 10) : 10;
    const search = typeof args === 'object' ? String(args?.search || '').trim() : '';
    const response = await getChamberListing(warehouseId, { page, limit, search: search || undefined });
    if (!response.ok) {
      return rejectWithValue(response.data?.message || 'Failed to fetch chamber list');
    }
    const pagination = response.data?.pagination || response.data?.data?.pagination || {};
    return {
      warehouseId,
      rows: extractChamberList(response.data),
      pagination: {
        page: Number(pagination.page ?? page),
        limit: Number(pagination.limit ?? limit),
        total: Number(pagination.total ?? 0)
      }
    };
  }
);

const chamberSlice = createSlice({
  name: 'chamber',
  initialState: {
    rows: [],
    warehouseId: null,
    status: 'idle',
    error: null,
    pagination: {
      page: 1,
      limit: 10,
      total: 0
    }
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChamberListing.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchChamberListing.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.warehouseId = action.payload.warehouseId;
        state.rows = action.payload.rows;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchChamberListing.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch chamber list';
      });
  }
});

export default chamberSlice.reducer;
